import { List, ListItem } from '@mui/material'
import { observer } from 'mobx-react-lite'

import { AcSelect, AcSidemenuItem } from '@components'
import { useIsMd } from '@hooks/use-isMd'
import { useLocation, useNavigate } from 'react-router-dom'
import { useMemo } from 'react'
import { KEYS, LABELS } from '@constants'

interface IAcGenericViewAsideMenu {
  items: any[]
  isChild?: boolean
}

export const AcGenericViewAsideMenu = observer(
  ({ items }: IAcGenericViewAsideMenu) => {
    const navigate = useNavigate()
    const location = useLocation()
    const isMd = useIsMd()

    const renderContent = useMemo(() => {
      if (isMd) {
        return (
          <List
            role={'menu'}
            sx={{ minWidth: 244 }}>
            {items.map(menuItem => (
              <ListItem
                key={menuItem.id}
                role={'menuitem'}
                disablePadding>
                <AcSidemenuItem
                  active={location.pathname.substring(1) === menuItem.slug}
                  onClick={() => navigate(`/${menuItem.slug}`)}
                  label={menuItem.name}
                />
              </ListItem>
            ))}
          </List>
        )
      }

      return (
        <AcSelect
          options={items}
          emptyLabel={''}
          selectLabel={LABELS.PAGES}
          key={'page'}
          value={location.pathname.substring(1)}
          valueKey={KEYS.SLUG}
          labelKey={KEYS.NAME}
          onChangeCallback={value => {
            navigate(`/${value}`)
          }}
        />
      )
    }, [isMd, location, items])

    return renderContent
  },
)
